export default {
    //Splash
    splash_message: 'Байланыс және оқу платформасы',

    //TTCC
    accept_ttcc: 'Пайдалану шарттары мен ережелерін қабылдаңыз',

    //Login
    welcome: 'Қош келдіңіз!',
    welcome_message: 'dots, байланыс және оқу бойынша жаңа технологиялық серіктесіңіз.',
    username: 'Пайдаланушы аты',
    password: 'Құпия сөз',
    code: 'Код',
    recover_password: 'Құпия сөзді қалпына келтіру',
    log_in: 'Кіру',
    log_in_biometrics: 'Биометриялық деректермен кіріңіз',
    create_user: 'Пайдаланушы жасау',
    recover_access_to_account: 'Тіркелгіңізге кіруді қалпына келтіру үшін пайдаланушы атыңызды енгізіңіз',
    back: 'Артқа',
    enter_new_password: 'Код пен жаңа құпия сөзіңізді енгізіңіз',
    enter_code: 'Код енгізіңіз',
    new_password: 'Жаңа құпия сөз',
    repeat_new_password: 'Жаңа құпия сөзді қайталаңыз',
    validate: 'Растау',
    complete_all_fields: 'Барлық өрістерді толтырыңыз',
    passwords_do_not_match: 'Құпия сөздер сәйкес келмейді',
    user_created_successfully: 'Пайдаланушы сәтті жасалды',
    create_user: 'Пайдаланушы жасау',
    required_fields: 'Міндетті өрістер',
    confirm_your_email: 'Электрондық поштаңызды растаңыз',
    confirm_your_phone: 'Телефоныңызды растаңыз',
    confirm_password: 'Құпия сөзді растаңыз',
    modifying_email: 'Сіз электрондық поштаңызды өзгертесіз',
    validate_code: 'Кодты растаңыз',
    code_sent_successfully: 'Код сәтті жіберілді',
    password_reset: 'Құпия сөзіңіз сәтті қалпына келтірілді',
    enter_confirmation_code: 'Растау кодын енгізіңіз',
    enter_your_new_email: 'Жаңа электрондық поштаңызды енгізіңіз',
    //nuevos al 01-08-2024
    user_does_not_exist: 'Пайдаланушы жоқ',
    contact_the_administrator: 'Әкімшіге хабарласыңыз',
    invalid_user_or_pass: 'Жарамсыз пайдаланушы аты және/немесе құпия сөз',
    info_is_not_correct: 'Кейбір ақпарат дұрыс емес, қайтадан көріңіз.',
    enter_user: 'Пайдаланушы атын енгізіңіз',
    nonexistent_user: 'Пайдаланушы жоқ. Қайтадан көріңіз.',
    incorrect_code: 'Қате код',
    change_saved_successfully: 'Өзгеріс сәтті сақталды',
    pass_changed_successfully: 'Құпия сөз сәтті өзгертілді',
    check_your_email: 'Растау кодын енгізу үшін электрондық поштаңызды тексеріңіз',
    eight_characters: '*8 таңбадан артық болуы керек',
    one_uppercase_letter: '*Кем дегенде 1 бас әріп болуы керек',
    one_special_character: '*Кем дегенде 1 арнайы таңба болуы керек (@,$,!,#,?)',
    pass_requirements:
        'Сіз келесі талаптарға сай болуыңыз керек:\n\n*8 таңбадан артық болуы керек\n*Кем дегенде 1 бас әріп болуы керек\n*Кем дегенде 1 арнайы таңба болуы керек (мысалы: $, !, #, ?)',
    select_date: 'Күнді таңдаңыз',
    cannot_create_password: 'Құпия сөзді жасау мүмкін емес',
    complete_your_details: 'Жалғастыру үшін мәліметтеріңізді толтырыңыз',
    validate_code: 'Кодты растау',
    enter_valid_number: 'Жарамды нөмір енгізуіңіз керек',
    complete_numbers:
        '"15" префиксі жойылуы керек, сондықтан соңғы нөмірде барлығы 13 сан болуы керек, мысалы: +54 9 XXX XXX XXXX, қалған 10 санды толтыруыңыз керек.',

    //Profile
    insufficient_permissions: 'Рұқсаттар жеткіліксіз',
    permissions_are_required: 'Камера мен фото галереяға қол жеткізу үшін рұқсат қажет.',
    choose_font: 'Дереккөзді таңдаңыз',
    where_do_you_want: 'Суретті қайдан таңдамақсыз?',
    camera: 'Камера',
    gallery: 'Галерея',
    edit_photo: 'Суретті өңдеу',
    cancel: 'Бас тарту',
    save: 'Сақтау',
    app: 'Қолданба',
    support: 'Қолдау',
    other: 'Басқа',
    contact_channel: 'Байланыс арнасы',
    select_the_contact_channel: 'Байланыс арнасын таңдаңыз',
    subject: 'Тақырып',
    write_the_subject: 'Тақырыпты жазыңыз',
    message: 'Хабарлама',
    write_a_comment: 'Пікір жазыңыз',
    send: 'Жіберу',
    sent_successfully: 'Сәтті жіберілді',
    thank_you_for_leaving_us_your_comments: 'Пікірлеріңіз үшін рахмет, жақын арада сізбен хабарласамыз.',
    close: 'Жабу',
    check_for_update: 'Жаңартуларды тексеру',
    clear_cache: 'Кэшті тазалау',
    delete_account: 'Тіркелгіні жою',
    log_out: 'Шығу',
    notifications: 'Хабарландырулар',
    insufficient_permissions: 'Рұқсаттар жеткіліксіз',
    permissions_to_access: 'Камера мен фото галереяға қол жеткізу үшін рұқсат қажет.',
    choose_font: 'Дереккөзді таңдаңыз',
    select_the_image: 'Суретті қайдан таңдамақсыз?',
    change_language: 'Тілді өзгерту',
    change_language_title: 'Маңызды!',
    change_language_message:
        'Бұл әрекетті орындау үшін интернет байланысы болуы керек. Бұл желіден тыс пайдалану үшін жүктеп алынған мазмұнды жояды. Өзгеріс құрылғының тіліне байланысты қолданба құрылымына емес, тек қолданбаның мазмұнына әсер ететінін ескеріңіз.',
    logout_not_available: 'Шығу мүмкін емес',
    cant_logout: 'Қазіргі уақытта сіз интернетке қосылмағандықтан шығу мүмкін емес. Қосылымыңызды тексеріп, қайта көріңіз.',
    //nuevos al 01-08-2024
    cache_cleared: 'Кэш сәтті тазаланды',
    deletes_the_content:
        'Бұл әрекет қолданбаны желіден тыс режимде пайдалану үшін жүктеп алынған мазмұнды жояды. Шарлауды жалғастыру үшін қосылғаныңызға көз жеткізіңіз.',
    error_uploading_image: 'Суретті жүктеу кезінде қате: ',
    there_was_an_error: 'Суретті жүктеу кезінде қате пайда болды. Қайтадан көріңіз.',
    //nuevos al 21-11-2024
    email: 'Электрондық пошта',
    phone: 'Телефон',
    name: 'Аты',
    last_name: 'Тегі',
    role: 'Рөлі',
    verify: 'Тексеру',
    verified: 'Тексерілді',
    contact_channels: 'Байланыс арналары',
    editing_your_email: 'Сіз электрондық поштаңызды өңдеп жатырсыз',
    editing_your_phone: 'Сіз телефон нөміріңізді өңдеп жатырсыз',
    modifying_your_email:
        'Сіз электрондық поштаңызды өзгертіп жатырсыз, оны енгізу үшін электрондық поштаңызға код жіберіледі. Егер кодты әлі алмаған болсаңыз, қайтадан тексеріңіз.',
    modifying_your_phone:
        'Сіз ұялы телефон нөміріңізді өзгертіп жатырсыз, оны енгізу үшін SMS арқылы код жіберіледі. Егер кодты әлі алмаған болсаңыз, қайтадан тексеріңіз.',

    //Notifications
    all: 'Барлығы',
    unread: 'Оқылмаған',
    read: 'Оқылған',
    seen: 'Көрілген',
    notifications: 'Хабарландырулар',
    here_you_will_find: 'Мұнда барлық ескертулер мен хабарландыруларды табасыз!',
    mark_all_read: 'Барлығын оқылған деп белгілеу',
    you_have_no_notifications: 'Сізде хабарландырулар жоқ!',
    you_will_soon_start: 'Жақын арада жаңа хабарламалар аласыз',

    //Buscador
    enter_your_search: 'Іздеуді енгізіңіз',
    no_results: 'Нәтижелер табылмады',
    search_content: 'Қызықтырған мазмұнды іздеңіз.',
    see: 'Қарау',
    results_in: 'нәтижелер',
    see_less_results: 'Аз нәтижелерді көрсету',
    all: 'Барлығы',
    wall: 'Қабырға',
    learning: 'Оқу',
    benefits: 'Артықшылықтар',
    portfolio: 'Портфолио',
    retry: 'Қайталау',
    locked: 'Бұғатталған',
    pending: 'Күту режимінде',
    seen: 'Көрілген',
    approved: 'Бекітілген',

    //Posts
    see_them: 'Барлығын көру',
    _comments: ' пікірлер',
    reactions_from_other_users: 'Басқа пайдаланушылардың реакциялары',
    not_connected_to_the_network: 'Желіге қосылмаған',
    comment: 'Пікір',
    comments: 'Пікірлер',
    write_a_comment: 'Пікір жазыңыз',
    no_content: 'Мазмұн жоқ',
    not_connected_to_the_network: 'Сіз желіге қосылмағансыз',
    reaction: 'Реакция',
    reactions: 'Реакциялар',
    first_comment: 'Бірінші болып пікір қалдырыңыз!',
    no_comment: 'Бұл жазбада әлі пікірлер жоқ.',
    write_a_comment: 'Пікір жазыңыз',
    no_publications: 'Жарияланымдар жоқ',
    no_post_to_read: 'Сізде оқуға жазбалар жоқ.',
    views: 'қараулар',
    reply: 'Жауап беру',
    see: 'Қарау',
    more_answers: 'көп жауаптар',
    hide: 'Жасыру',
    answers: ' жауаптар',
    no_reactions: 'Әлі реакциялар жоқ!',
    leave_your_reaction: 'Бірінші болып реакция қалдырыңыз.',
    //nuevos al 01-08-2024
    full_survey: 'Сіз сауалнаманы аяқтадыңыз!',
    thanks_for_participating: 'Қатысқаныңыз үшін рахмет! Қосымша жаңартулар үшін қабырғаны қадағалаңыз.',
    sent_automatically: 'Қайта байланыс орнатылғанда автоматты түрде жіберіледі.',
    no_post_saved: 'Әзірге сақталған жазбалар жоқ',
    see_your_favorite_content: 'Мұнда сіз өзіңіздің сүйікті мазмұныңызды көресіз.',
    //fechas
    instant: 'Сәл бұрын',
    hourFirst: 'Бұрын',
    hour: ' сағат',
    hours: ' сағат',
    day: ' күн',
    days: ' күн',

    //Learning
    congratulations: 'Құттықтаймыз!',
    you_approved: 'Сіз сәтті тапсырдыңыз ',
    you_completed: 'Сіз бұл курсты аяқтадыңыз',
    you_disapproved: 'Бағалау сәтсіз аяқталды',
    score: 'Бағалау:',
    return_to_course: 'Басты бетке оралу',
    retry: 'Қайталау',
    it_is_available: 'Енді қолжетімді',
    total_course_evaluation: 'Курстың жалпы бағасы',
    evaluate_me: 'МЕНІ БАҒАЛАУ',
    completed_the_course: 'Сіз курсты аяқтадыңыз',
    pending_approval: 'Бекіту күтілуде',
    return: 'Артқа',
    continue_course: 'Курсты жалғастыру',
    you_have_made: 'Сіз аяқтадыңыз',
    of_the_course: ' курстың',
    locked: 'бұғатталған',
    pending: 'күту режимінде',
    seen: 'көрілген',
    complete: 'аяқтау',
    reprobate: 'сәтсіз',
    sync_pend: 'синхрондау күтілуде',
    in_progress: 'жұмыста',
    perform_evaluation: 'Бағалауды орындау',
    next_content: 'Келесі мазмұн',
    you_completed_all: 'Сіз барлық мазмұнды аяқтадыңыз',
    final_evaluation: 'ҚОРЫТЫНДЫ БАҒАЛАУ',
    retry_mayus: 'ҚАЙТАЛАУ',
    see_more: '...көбірек',
    see_less: '...аз',
    back_to_course: 'КУРСҚА ОРАЛУ',
    click_to_see: 'Көру үшін басыңыз',
    //Evaluaciones
    evaluation: 'Бағалау: ',
    of: ' ден ',
    loading_evaluation: 'Бағалау жүктелуде...',
    select_option: 'Жалғастыру үшін нұсқаны таңдауыңыз керек',
    select_one_answer: 'Әр сұрақ үшін кемінде бір жауап таңдаңыз.',
    exit_evaluation: 'Бағалаудан шығасыз ба?',
    your_answers_will_not_be_saved: 'Егер қазір шығып кетсеңіз, жауаптарыңыз сақталмайды және баға алмайсыз',
    continue_evaluation: 'Бағалауды жалғастыру',
    leave_anyway: 'Қалай болса да шығу',
    try_again: 'Қайталап көріңіз!',
    passed_the_evaluation: 'Сіз бағалауды сәтті тапсырдыңыз',
    start_the_course_again: 'Бағалауды аяқтамадыңыз. Курсты қайта бастау қажет.',
    evaluation_pending_approval: 'Бағалау күтілуде',
    notification_result_evaluation: 'Бағалау нәтижесі туралы жақын арада хабарланасыз',
    write_here: 'Мұнда жазыңыз...',
    close: 'Жабу',
    confirm: 'Растау',
    sync_pending: 'Синхрондау күтілуде',
    view_certificate: 'Куәлікті көру',
    search_store: 'Дүкен іздеу...',
    no_results_for_your_search: 'Іздеуіңіз бойынша нәтиже табылмады',
    find_another_store: 'Басқа дүкенді іздеңіз',
    // nuevos al 27-01-2025
    course_download_in_process: 'Курс жүктелуде',
    course_is_downloading: 'Бірнеше секунд күтіңіз. Курс жүктелуде, сонда сіз барлық мазмұнды офлайн режимде еш қиындықсыз көре аласыз.',
    downloaded_course: 'Курс сәтті жүктелді',
    you_can_train_offline: 'Дайын! Енді сіз офлайн режимде оқи аласыз.',
    delete_offline_course: 'Бұл курстың офлайн жүктелуін жоюғыңыз келе ме?',
    not_view_course_offline: 'Сіз бұл курсты офлайн режимде көре алмайсыз.',
    course_is_not_available: 'Курс енді қолжетімді емес...',
    not_available_offline: 'Бұл курс енді офлайн қолжетімді емес, бірақ қажет болғанда оны қайтадан жүктей аласыз.',
    content_download_in_process: 'Мазмұн жүктелуде',
    content_is_downloading: 'Бірнеше секунд күтіңіз. Мазмұн жүктелуде, сонда сіз оны офлайн режимде еш қиындықсыз көре аласыз.',
    downloaded_content: 'Мазмұн сәтті жүктелді',
    delete_offline_content: 'Офлайн мазмұнын жойғыңыз келе ме?',
    not_view_content_offline: 'Оны жойған кезде, сіз мазмұнды офлайн режимде көре алмайсыз.',
    content_is_not_available: 'Мазмұн енді қолжетімді емес...',
    download_offline: 'Офлайн жүктеу',
    available_offline: 'Офлайн қолжетімді',
    delete: 'Жою',
    //Stores
    your_progress_in_stores: 'Дүкендердегі жетістіктеріңіз',
    map: 'Карта',
    daily_survey: 'Күнделікті сауалнама',
    survey: 'Сауалнама',
    matutino: 'Таңертең',
    vespertino: 'Кешке',
    form: 'Форма',
    enter_a_number: 'Нөмір енгізіңіз',
    campaign_expiration: 'КАМПАНИЯ МЕРЗІМІ: ',
    store_indicators: 'Дүкен көрсеткіштері',
    last_days: 'Соңғы 30 күн',
    main_indicators: 'Дүкеніңіздің негізгі көрсеткіштерін біліңіз',
    store_information: 'Дүкен туралы толық ақпаратты табыңыз',
    perform_executions: 'Дүкеніңіздің жай-күйін білу үшін келесі тапсырмаларды орындаңыз',
    pending_mayus: 'КҮТУ РЕЖИМІНДЕ',
    approved_mayus: 'БЕКІТІЛГЕН',
    in_review_mayus: 'ҚАРАУДА',
    redo_mayus: 'ҚАЙТАЛАУ',
    visited_mayus: 'ТЕКСЕРІЛДІ',
    moderation_mayus: 'МОДЕРАЦИЯ',
    review_mayus: 'ҚАРАУ',
    in_progress_mayus: 'ЖҰМЫСТА',
    sync_pend_mayus: 'СИНХРОНДАУ КҮТІЛУДЕ',
    locked_mayus: 'БҰҒАТТАЛҒАН',
    complete_mayus: 'ТОЛЫҚ',
    perfect_store: 'Мінсіз дүкен',
    execution: 'Орындау',
    vouchers: 'Ваучерлер',
    send: 'Жіберу',
    requires: 'Талап етеді ',
    variation: 'Айырмашылық',
    validity: 'Жарамдылық мерзімі: ',
    points: 'ұпай',
    voucher_canceled: 'Ваучер жойылды',
    you_can_try_again: 'Уайымдамаңыз! Қайта көріңіз.',
    voucher_successful: 'Ваучер сәтті орындалды',
    successful_promo: 'Акция сәтті өтті!',
    voucher_pending: 'Ваучер күтілуде',
    wait_for_the_validation: 'Ваучердің расталуын күтіңіз',
    your_code_is_being_scanned: 'Код сканерленуде ⏳',
    view_qr: 'QR көру',
    return_to_store: 'Дүкенге оралу',
    stores_objective: 'Дүкеннің мақсатын орындау қажет.',
    welcome_stores: 'Дүкендерге қош келдіңіз!',
    tip_day: 'Мұнда сіз күнделікті дүкендеріңізді көре аласыз, қажетті сауалнамаларды орындай аласыз және жетістіктеріңізді қадағалай аласыз.',
    close_mayus: 'ЖАБУ',
    select_form: 'Бастау үшін форманы таңдаңыз',
    select_one_form: 'Сауалнаманы бастау үшін бір форманы таңдауыңыз керек.',
    answer_all_questions: 'Жалғастыру үшін барлық сұрақтарға жауап беруіңіз керек.',
    schedule_not_found: 'Бүгінге кесте табылмады.',
    form_not_found: 'Кестеде форма табылмады.',
    send: 'Жіберу',
    check_in: 'Тіркелу',
    check_out: 'Шығу',
    check_out_done: 'Шығу сәтті орындалды',
    off_route: 'Жолдан тыс қалдыңыз, кестеге қайта оралу үшін мұнда басыңыз',
    search_barcode: 'Штрих-код бойынша іздеу',
    no_agenda_today: 'Бүгінгі күнге арналған кестеңіз жоқ!',
    no_agenda_week: 'Осы аптаға арналған кестеңіз жоқ!',
    no_information_today: 'Бұл күнге арналған кестеңіз жоқ, егер сұрақтарыңыз болса, жетекшіңізбен байланысыңыз.',
    no_information_week: 'Пайдаланушыға арналған мәліметтер алынбайды, егер сұрақтарыңыз болса, жетекшіңізбен байланысыңыз.',
    //nuevos al 01-08-2024
    not_have_camera_permissions: 'Сізде камера рұқсаттары жоқ',
    activate_from_settings: 'Жалғастыру үшін құрылғыңыздың параметрлерінен қосыңыз.',
    modify_permissions: 'Рұқсаттарды өзгерту',
    complete_fields: 'Дүкен жасау үшін келесі өрістерді толтырыңыз',
    create: 'Жасау',
    store_name: 'Дүкен атауы',
    enter_store_name: 'Дүкен атауын енгізіңіз',
    sore_address: 'Мекенжай',
    enter_sore_address: 'Дүкеннің мекенжайын енгізіңіз',
    cluster: 'Кластер',
    store_phone: 'Телефон',
    enter_sore_phone: 'Дүкеннің телефон нөмірін енгізіңіз',
    activate_survey: '1.1 Vespertino сауалнамасын іске қосу үшін дүкеннің мақсаттарын орындауыңыз қажет. Мақсаттар: ',
    inactive_vespertino: 'Vespertino белсенді емес',
    active_vespertino: 'Vespertino белсенді',
    completed_your_mandatory_objectives: 'Сіз күннің міндетті мақсаттарын орындадыңыз, енді Vespertino-ны орындай аласыз.',
    complete_now: 'Қазір орындаңыз',
    perform_later: 'Кейін орындаңыз',
    back_to_your_agenda: 'Күніңіздің жоспарына қайта оралғыңыз келе ме?',
    return_to_the_current_day: 'Сіз өткен күндердегі әрекеттерді қарап отырсыз, егер жалғастыруды бассаңыз, ағымдағы күнге қайта ораласыз: ',
    continue: 'Жалғастыру',
    reached_your_goal: 'Мақсатыңызға жеттіңіз!',
    search_by_barcode: 'Баркод бойынша іздеу',
    scan_the_barcode: 'Бұл сұрау тізіміндегі кез келген өнімнің баркодын сканерлеңіз.',
    return_to_form: 'Формаға қайта оралу',
    product_not_found: 'Өнім табылмады',
    code_does_not_match: 'Код осы формаға сәйкес өніммен сәйкес келмейді.',
    search_another_product: 'Басқа өнімді іздеңіз',
    form_submitted_successfully: ' табысты болды!',
    send_new_survey: 'Қалаған жағдайда жаңа сауалнама жібере аласыз.',
    no_agenda_for_today: 'Бүгінге арналған күн тәртібі жоқ!',
    consult_your_supervisor: 'Осы күнге арналған күн тәртібі жоқ, кез келген сұрақтар бойынша жетекшіңізге хабарласыңыз.',
    visiting_your_store: 'Сіз өз дүкеніңізге бардыңыз ',
    you_can_check_out: 'Сауалнаманы аяқтамай-ақ тіркеуден шығуға болады: ',
    you_met_the_goal: 'Сіз мақсатқа жеттіңіз, форманы толтырудың қажеті жоқ.',
    you_must_complete_the_survey: 'Тіркеуден шығу үшін сауалнаманы толтыруыңыз керек: ',
    checkin_blocked: 'Тіркелу бұғатталды',
    close_the_open_checkin: 'Жалғастыру үшін ашық тіркеуді жабу керек.',
    close_the_checkin_opened_in: 'Жалғастыру үшін ашық тіркеуді жабу керек: ',
    checkin_out_of_range: 'Тіркелу ауқымнан тыс',
    more_meters_from_the_store: 'Сіз дүкеннен 150 метрден астам қашықтықта тұрсыз.',
    now_is_your_turn: 'Енді сіздің кезегіңіз!',
    surveys_in_progress: 'Сізде аяқталмаған сауалнамалар бар: ',
    unfinished_surveys: 'Сізде аяқталмаған сауалнамалар бар: ',
    want_to_checkout: 'Шынымен тіркеуден шыққыңыз келе ме?',
    selected_store: 'Таңдалған дүкен',
    checkout_blocked: 'Тіркеуден шығу бұғатталды',
    uncompleted_forms: 'Сізде аяқталмаған формалар бар!',
    checkout_anyway: 'Сіз бәрібір тіркеуден шыққыңыз келе ме?',
    go_to_survey: 'Сауалнамаға өту',
    take_the_survey: 'Енді сіз сауалнаманы орындауға болады!',
    validity: 'Жарамдылық: ',
    //nuevos al 21-11-2024
    loading: 'Жүктеліп жатыр...',
    error_getting_data: 'Деректерді алу қателігі.',
    no_information_to_display: 'Көрсету үшін ақпарат жоқ.',
    unzipping: 'Шығару...',
    saving: 'Сақталуда',
    loading_stores: 'Дүкендер жүктеліп жатыр...',
    getting_stores: 'Дүкендер алынып жатыр...',
    request_has_failed: 'Максималды қайта әрекет ету санына жетті. Сұрау сәтсіз аяқталды.',
    a_few_minutes: 'Дүкендер жүктеліп жатыр...\nБұл процесс бірнеше минутты алуы мүмкін.',
    //nuevos al 27-01-2025
    assets_download_completed: 'Perfect Store ресурстарының жүктелуі аяқталды',
    perfect_store_download: 'Perfect Store сәттілік фотосы жүктелуі аяқталды',
    perfect_store_error: 'Perfect Store ресурстарын жүктеу кезінде қате пайда болды',
    connection_interrupted: 'Байланыс үзіліп кетті, байланыс қалпына келтірілгеннен кейін сәттілік фотосы ашылады',
    decompressing_perfect_store: 'Perfect Store жүктеп алынуда',
    downloading_perfect_store: 'Perfect Store жүктелуде',
    saving_perfect_store: 'Perfect Store сақталуда',
    remain_downloaded: '\nЖүктелуі қажет қалған ',
    assets: ' ресурстар.',
    download_complete: 'Жүктеу аяқталды',

    //Portfolio
    no_brands_to_show: 'Көрсетілетін брендтер жоқ',
    no_products_to_show: 'Көрсетілетін өнімдер жоқ',
    try_again_later: 'Кейінірек қайта көріңіз',
    portfolio: 'Портфолио',
    select_one: 'Өнімдер мен қызметтерді көру үшін брендтеріміздің бірін таңдаңыз.',
    learn_about: 'Біздің қолданбадағы барлық өнімдер мен қызметтер туралы біліңіз.',
    //nuevos al 01-08-2024
    brand: 'Бренд',
    description: 'Сипаттамасы',
    ingredients: 'Құрамы',
    data_sheet: 'Техникалық парақ',

    //Benefits
    points_can_be_exchanged: 'Ұпайлар келесіге айырбасталуы мүмкін:',
    approved: 'Бекітілген',
    cancelled: 'Жойылған',
    pending: 'Күту режимінде',
    redeemed: 'ҚҰТҚАРЫЛҒАН',
    added_points: 'ҰПАЙЛАР ҚОСЫЛДЫ',
    all: 'Барлығы',
    my_points: 'Менің ұпайларым',
    your_points: 'Сіздің ұпайларыңыз',
    delivered: 'Жеткізілді',
    no_benefits: 'Әзірге ешқандай пайда жоқ',
    add_points: 'Өзара әрекеттесу арқылы ұпай жинап, оларды құтқарыңыз',
    no_history: 'Әзірге тарих жоқ',
    redeem_your_points: 'Ұпайларыңызды құтқарыңыз және артықшылықтар тарихын осында қараңыз',
    pending_approval: 'Бекіту күтілуде',
    when_it_is_approved: 'Бекітілгеннен кейін ол артықшылықтар тарихында көрсетіледі',
    unredeemed_benefit: 'Құтқарылмаған пайда',
    you_dont_have_enough_points: 'Бұл пайданы құтқару үшін жеткілікті ұпайларыңыз жоқ',
    accept: 'Қабылдау',
    units_available: ' қолжетімді бірліктер',
    redeem_benefit: 'Пайданы құтқару',
    benefits_mayus: 'АРТЫҚШЫЛЫҚТАР',
    history: 'ТАРИХ',
    there_was_a_mistake: 'Қате орын алды',

    //Vouchers
    complete_to_redeem_the_voucher: 'Ваучерді құтқару үшін толтырыңыз',
    valid_until: 'Жарамдылық мерзімі: ',
    quantity_purchased: 'Сатып алынған сан: ',
    redeem: 'Құтқару',
    lumps: 'Бөліктер',
    voucher_redeemed: 'Ваучер сәтті құтқарылды',
    error_redeeming_voucher: 'Ваучерді құтқару кезінде қате орын алды. Қайта көріңіз.',
    validate_and_redeem_vouchers: 'Ваучерді растау және құтқару',
    to_get_started: 'Бастау үшін камераңызбен ваучеріңіздің QR кодын енгізіңіз немесе сканерлеңіз',
    write_your_code: 'Кодыңызды жазыңыз...',
    validate: 'Растау',
    back_to_store: 'Дүкенге оралу',
    scan_qr: 'QR кодын сканерлеңіз',
    scan_on_the_voucher: 'Бастау үшін, ваучердің QR кодын сканерлеңіз',
    view_history: 'Тарихты қарау',
    voucher_history: 'Ваучер тарихы',
    voucher_history_description:
        'Бұл тарих сізге жасалған алмасуларды дәл қадағалауға мүмкіндік береді, жинақталған сыйақыларыңызды бақылауды және басқаруды жеңілдетеді.',
    see_more: 'Көбірек көру',
    see_less: 'Аз көрсету',

    //Faltantes
    upload_image: 'Суретті жүктеу',
    uploaded_image: 'Жүктелген сурет',
    photo: 'Фото',
    edit: 'Өңдеу',
    delete: 'Жою',
    enter_a_comment: 'Пікір енгізіңіз',
    enter_a_value: 'Мән енгізіңіз',
    want_to_check_out: 'Чығуды қаласаңыз, сенімдісіз бе?',
    not_check_in_again: 'Бір рет растағаннан кейін, келесі сапарыңызға дейін қайта тіркеле алмайсыз.',

    //Alert
    alert: 'Ескерту',
    enter_characters: 'Сіз префикстен кейін 10 таңба енгізуіңіз керек',
    numerical_field: 'Өңделетін өріс сандық болуы керек, бос орындар мен әріптерсіз.',
    enter_date_of_birth: 'Туған күнді YYYY-MM-DD форматында дұрыс енгізіңіз.',
    session_expired: 'Сессия аяқталды',
    your_session_has_expired: 'Сессияңыз аяқталды. Қайтадан көріңіз.',
    error: 'Қате',
    error_occurred: 'Құпия сөзді өзгерту әрекеті кезінде қате орын алды.',
    email_verification_code_incorrect: 'Электрондық поштаны растау коды дұрыс емес.',
    phone_verification_code_incorrect: 'Телефонды растау коды дұрыс емес.',
    no_checkin_found: 'Тіркеу табылмады.',

    //trivia
    your_position: 'Your position',
    play_again: 'Play again!',
    next: 'Next',
    position: 'Position',
    Questions: 'Question:',
    answer_right: 'The correct answer is:',
    game_completed_title1: 'Game completed!',
    game_completed_title2: 'Congratulations!',
    game_completed_title3: 'You finished the trivia.',
    game_completed_title4: 'Ready to see your results? Discover how many answers you got right and challenge yourself to improve your score.',
    game_unfinished_title1: 'Time is up for answering this or the questions.',
    game_unfinished_title2: "But don't worry, keep playing and show your knowledge in the next one!",
    tomorrow_again: 'New attempt tomorrow!',
    complete: 'Complete',
}
